import React from 'react';
import styles from '../HomeV3.module.css';

export function DashboardSkeleton() {
    return (
        <main className={styles.dashboard} aria-busy="true" aria-label="Loading Home dashboard">
            <div className={styles.stack}>
                <div className={styles.skeletonBlock} />
                <div className={styles.kpiRibbon}>{Array.from({ length: 4 }, (_, index) => <div key={index} className={styles.skeletonBlock} />)}</div>
                <div className={styles.grid}><div className={`${styles.skeletonBlock} ${styles.workflowPanel}`} /><div className={`${styles.skeletonBlock} ${styles.exercisePanel}`} /></div>
            </div>
        </main>
    );
}
